export interface HashMap<T> {
    [key: string]: T;
}

export function arrayToHashMap<T>(array: T[],  key: keyof T): HashMap<T> {
    return array.reduce((map, item) => {
        const keyValue = item[key];
        if (typeof keyValue === "string") {
            map[keyValue] = item;
        } else {
            throw new Error("The specified key must resolve to a string.");
        }
        return map;
    }, {} as HashMap<T>);
}